package com.klantenstop.web.data.models.dto.responses.moderation

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

enum class ModerationEntityType {
    COMPANY,
    STATUS,
    REVIEW,
}

enum class ModerationActionType {
    CREATE,
    UPDATE,
}

enum class ModerationStatus {
    PENDING,
    APPROVED,
    REJECTED,
    SUPERSEDED,
    ARCHIVED,
}

@Serializable
data class ModerationEntryDto(
    val id: String = "",
    @SerialName("entity_type")
    val entityType: ModerationEntityType = ModerationEntityType.COMPANY,
    @SerialName("entity_id")
    val entityId: String = "",
    @SerialName("entity_name")
    val entityName: String? = null,
    @SerialName("snapshot_type")
    val snapshotType: ModerationEntityType = ModerationEntityType.COMPANY,
    @SerialName("snapshot_id")
    val snapshotId: String = "",
    @SerialName("action_type")
    val actionType: ModerationActionType = ModerationActionType.CREATE,
    val status: ModerationStatus = ModerationStatus.PENDING,
    @SerialName("submitted_by_user_id")
    val submittedByUserId: String? = null,
    @SerialName("submitted_by_user_name")
    val submittedByUserName: String? = null,
    @SerialName("moderated_by_user_id")
    val moderatedByUserId: String? = null,
    @SerialName("moderated_at")
    val moderatedAt: String? = null,
    @SerialName("rejection_reason")
    val rejectionReason: String? = null,
    @SerialName("sequence_number")
    val sequenceNumber: Int = 0,
    @SerialName("created_at")
    val createdAt: String = "",
    @SerialName("updated_at")
    val updatedAt: String = "",
)
